/**
 * NumberUtil.ts
 *
 * For rounding numbers.
 */
export class NumberUtil {
    /**
     * Converts a number to a string then back to a shorter number.
     * @param value - Number to round.
     * @param precision - How many decimal points to round to. Default 2
     * @returns Rounded number.
     */
    static round(value, precision = 2) {
        return parseFloat(value.toFixed(precision));
    }
    /**
     * Generates a "fuzzy" number by adding or subtracting a random offset.
     *
     * @param baseValue - Middle of range.
     * @param fuzzyRange - Twice the maximum offset from `baseValue`.
     * @returns `baseValue` plus or minus a random offset.
     */
    static fuzzyNum(baseValue, fuzzyRange) {
        const fuzz = fuzzyRange * Math.random() - fuzzyRange / 2;
        return baseValue + fuzz;
    }
}
//# sourceMappingURL=NumberUtil.js.map